import { useState } from "react";
import { useAppContext } from "../../../AppContext";
import { UserRole } from "../../../common/enums";
import { getCurrentUserRole } from "../../../common/infrastructure/helpers/userHelper";
import { aiExampleQuestions } from "../models/aiExampleQuestions";
import { pickExampleQuestions } from "../utilities/aiExampleQuestionsUtility";

// The roles the API gives the trend and at-risk tools (UsersUtility.GetRolesThatCanSeeAllUsers).
const ANALYTICS_ROLES = [UserRole.Tenant, UserRole.Employee_Manager, UserRole.GlobalAdmin];

/** A fresh set of example chips each time the empty chat appears; stable while it stays on screen. */
export const useAiExampleQuestions = (): string[] => {
  const { currentUser } = useAppContext();
  const role = getCurrentUserRole(currentUser);
  const [questions] = useState(() =>
    pickExampleQuestions(aiExampleQuestions, role !== undefined && ANALYTICS_ROLES.includes(role)),
  );
  return questions;
};
